export const Home = () => {
  return (
    <h1>
      Home Page
    </h1>
  )
}
